import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Player } from 'src/app/features/handball/player/model/player';
import { Card } from 'src/app/features/handball/cards/model/card';
import { PlayerBasicInfoComponent } from "../player-basic-info/player-basic-info.component";
import { TableModule } from 'primeng/table';
import { CardGridComponent } from '../../../card-grid/card-grid.component';
import { PlayerService } from '../../controller/player.service';

@Component({
  selector: 'app-player-health',
  templateUrl: 'player-health.component.html',
  styleUrls: ['player-health.component.scss'],
  standalone: true,
  imports: [CommonModule, PlayerBasicInfoComponent, CardGridComponent, TableModule]
})
export class PlayerHealthComponent implements OnInit, OnChanges {
  @Input() player: Player;

  cards: Card[] = []

  // Chart models
  playerPerformanceLast5MatchesTableData: {startDate: Date, endDate: Date, desc: string}[] = [];

  constructor(readonly playerDataService: PlayerService) { }

  async ngOnChanges() {
    if (this.player) {
      this.getCards();
    }
    this.updateGraphs();
  }

  async ngOnInit() {
    if (this.player) {
      this.getCards();
    }
    this.updateGraphs();
  }


  private async getCards() {


    this.cards = [
      {
        id: "1",
        label: 'Golpes',
        value: this.player.healthStats.numberOfBlows,
      },
      {
        id: "2",
        label: 'Saltos',
        value: this.player.healthStats.numberOfJumps,
      },
      {
        id: "3",
        label: 'Salto medio',
        value: this.player.healthStats.averageJumpHeightInCm + " cm",
      },
      {
        id: "4",
        label: 'Salto máximo',
        value: this.player.healthStats.maxJumpHeightInCm + " cm",
      },
      {
        id: "5",
        label: 'Aceleraciones',
        value: this.player.healthStats.numberOfAccelerations,
      },
      {
        id: "6",
        label: 'Desaceleraciones',
        value: this.player.healthStats.numberOfDecelerations,
      },
      {
        id: "7",
        label: 'Dirección (cambios izq.)',
        value: this.player.healthStats.numberOfChangesOfDirectionToLeft,
      },
      {
        id: "8",
        label: 'Dirección (cambios der.)',
        value: this.player.healthStats.numberOfChangesOfDirectionToRight,
      },
    ]
  }


  private async updateGraphs() {
    this.updatePlayerPerformanceLast5MatchesTableData();
  }

  private async updatePlayerPerformanceLast5MatchesTableData() {
    if (this.player === undefined || this.player === null) {
      this.playerPerformanceLast5MatchesTableData = []
    }

    this.playerPerformanceLast5MatchesTableData = this.playerDataService.getPlayerHealthProblems(this.player.id).map(
      l =>({
        startDate: l.dateFrom,
        endDate: l.dateTo,
        desc: l.desc
      })
    )
  }

}
